import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import EstoqueForm from '../components/EstoqueForm';
import EstoquePrintModal from "../relatorios/EstoquePrintModal";
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";


const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdePedNSinc: 0,
    qtdePed: 0,
    qtdeOrc: 0,
    vlrTotalPed: 0,
    vlrTotalOrc: 0,

    selectedRowKeys: [],

    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'INV',
      buscaOrdem: { campo: 'est_data', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaUsuario = {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, selectedRowKeys: [], });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaProduto, buscaGrupoProduto, buscaUsuario, buscaOrdem } = this.state.filtros;

    let data_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      data_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let data_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      data_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/estoque', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          // usuario: buscaUsuario.key,
          produto: buscaProduto.key,
          grupo: buscaGrupoProduto.key,
          data_ini,
          data_fim,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;

        // console.log('getListaRegistros', response.data)

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          // qtdePed: response.data.qtdePed,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);

    let request;
    if (registro.est_idf) {
      request = axios.put(`/estoque/update/${registro.est_idf}`, registro);
    } else {
      request = axios.post(`/estoque/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Inventário gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          est_idf: 0,
          est_produto: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          est_qtde_atual: 0,
          est_qtde_contada: 0,
          est_obs: '',
        }
      },
    })

  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/estoque/show/${registro.est_idf}`)
      .then(response => {
        const { data } = response;
        // console.log('-------------------------------onEditarClick: ', data)
        data.est_produto = {
          key: String(data.est_produto),
          label: String(data.prod_descricao),
        }
        // console.log('onEditarClick: ', data)

        this.setState({
          registroSelecionado: {
            dados: data,
            consulta: data.est_situacao === 'SIN' ? true : false
          },
          formVisivel: true,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onInventarioClick = () => {
    if ((!this.state.selectedRowKeys) || (this.state.selectedRowKeys.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Selecione algum Inventário' });
      return;
    }

    Modal.confirm({
      title: 'Gerar Inventário',
      content: `Deseja gerar inventário dos selecionados?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true })

        const reg = {
          lista: this.state.selectedRowKeys,
        }

        axios.put(`/estoque/gerarInventario`, reg)
          .then(response => {
            message.success('Inventários gravados com sucesso');
            this.setState({ carregando: false, selectedRowKeys: [] });
            this.getListaRegistros();
          })
          .catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/estoque/delete/${registro.est_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.est_idf === registro.est_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderStatus = (data, registro) => {
    const dataMoment = data ? moment(data) : '';
    const dataSincMoment = registro.est_data_env ? moment(registro.est_data_env) : '';
    if (registro.est_situacao === 'SIN') {
      if ((this.state.usuario) && ((!this.state.usuario.usu_tipo) || (getTemPermissao('UsuarioSupervisor', 'cons')))) {
        return (
          <span style={{ fontSize: 11 }}>
            <Tooltip title={dataSincMoment.format('DD/MM/YYYY HH:mm')}>
              <a onClick={() => this.onExcluiDataEnvClick(registro)}>
                SINCRONIZADO
              </a>
            </Tooltip>
          </span>
        )
      } else {
        return (
          <Tooltip title={dataMoment.format('DD/MM/YYYY HH:mm')}>
            <span style={{ fontSize: 11 }}>
              SINCRONIZADO
            </span>
          </Tooltip>
        )
      }
    } else {
      return (
        <span style={{ fontSize: 11 }}>{
          registro.est_situacao === 'PEN' ?
            <Tooltip title={dataMoment ? dataMoment.format('DD/MM/YYYY HH:mm') : ''}>
              <span style={{ fontSize: 11 }}>
                PENDENTE
              </span>
            </Tooltip>
            :
            <Tooltip title={dataMoment ? dataMoment.format('DD/MM/YYYY HH:mm') : ''}>
              <a onClick={() => this.onExcluiDataSincClick(registro)}>
                INVENTÁRIO
              </a>
            </Tooltip>
        }</span>
      )
    }
  }


  onExcluiDataSincClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir o Inventário?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true })
        axios.put(`/estoque/excluiDataSinc/${registro.est_idf}`)
          .then(response => {
            this.getListaRegistros();
            this.setState({
              listaRegistros: this.state.listaRegistros.concat([]),
              carregando: false
            })
          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
          })
      }
    })
  };


  onExcluiDataEnvClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a data de sincronização?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true })
        axios.put(`/estoque/excluiDataEnv/${registro.est_idf}`)
          .then(response => {
            this.getListaRegistros();
            this.setState({
              listaRegistros: this.state.listaRegistros.concat([]),
              carregando: false
            })
          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
          })
      }
    })
  };











  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('EstoquePage', 'editar') ? (
          <Tooltip title={registro.est_situacao === 'SIN' ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon={registro.est_situacao === 'SIN' ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('EstoquePage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={registro.est_situacao === 'SIN' ? true : false} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={true} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };

  renderValor = (est_vlr_total, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(est_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 10)}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, selectedRowKeys, registroSelecionado, filtros,
      total, pagina, limite, formFiltroVisivel } = this.state;

    // console.log('EstoquePage.this.state: ', this.state);

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;


    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Contagem de Estoque</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={24} style={{ marginTop: -5 }}>
              {(!this.state.tipoUsuario) || (getTemPermissao('EstoquePage', 'novo')) ? (
                <Button
                  onClick={this.onAdicionarClick}
                  className="pageFiltro-adicionar"
                >
                  Adicionar
                </Button>
              ) : null}

              <Button
                type="dashed"
                onClick={this.onInventarioClick}
                // className="pageFiltro-adicionar"
                style={{ marginRight: 15 }}
              >
                Gerar Inventário
              </Button>

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />


              <EstoquePrintModal
                filtros={filtros}
              // vlrTotalPed={this.state.vlrTotalPed}
              // qtdePed={this.state.qtdePed}
              // vlrTotalOrc={this.state.vlrTotalOrc}
              // qtdeOrc={this.state.qtdeOrc}
              // qtdePedNSinc={this.state.qtdePedNSinc}
              />

              <span style={{ marginLeft: 20, marginTop: 8, fontSize: 15, fontWeight: 'bold' }}>
                {hasSelected ? `Selecionados ${selectedRowKeys.length} items` : ''}
              </span>
            </Col>

          </Row>

          <EstoqueForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.est_idf)}
            rowSelection={rowSelection}
          >
            <Column
              key="est_data"
              dataIndex="est_data"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="est_data_env"
              dataIndex="est_data_env"
              title={this.renderTitulo("Sincronizado")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="grp_descricao"
              dataIndex="grp_descricao"
              title={this.renderTitulo("Grupo")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title={this.renderTitulo("Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"8%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title={this.renderTitulo("Descrição Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"15%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="est_qtde_atual"
              dataIndex="est_qtde_atual"
              title={this.renderTitulo("Qtde Atual")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="est_qtde_contada"
              dataIndex="est_qtde_contada"
              title={this.renderTitulo("Qtde Contada")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Usuário")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"15%"}
              align="center"
              className="listaCadastro"
              render={this.renderUsuario}
            />
            <Column
              key="est_data_sinc"
              dataIndex="est_data_sinc"
              title={this.renderTitulo("Status")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderStatus}
              width={'10%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ContagemEstoquePage.js